import React from 'react';
import { PaymentTrust } from './PaymentTrust';
export function PaymentBadges() {
  return <section className="py-16 px-6 bg-dark border-t border-gold/10" data-id="element-128">
      <div className="max-w-4xl mx-auto" data-id="element-129">
        <p className="text-gold/80 text-xs md:text-sm uppercase tracking-[0.25em] mb-8 font-semibold text-center" data-id="element-130">
          Secure Checkout — 100% Protected Payment
        </p>
        <PaymentTrust data-id="element-131" />
      </div>
    </section>;
}